import React from "react";

const WebIcon =()=>{
    return(
        <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 64 64"
  width="25"
  height="25"
>
  <circle cx="32" cy="32" r="30" stroke="black" stroke-width="2" fill="none" />
  <path
    d="M2 32a30 30 0 1 1 60 0 30 30 0 1 1 -60 0"
    stroke="black"
    stroke-width="2"
    fill="none"
  />
  <path
    d="M32 2v60M2 32h60"
    stroke="black"
    stroke-width="2"
  />
  <ellipse cx="32" cy="32" rx="20" ry="10" fill="white" />
  <text x="32" y="35" font-size="10" text-anchor="middle" fill="black" font-weight="bold">www</text>
</svg>
    )
}

export default WebIcon